/* esm.sh - unhead@3.1.0/dist/shared/unhead.fg-0ge_u */
export * from "/*unhead@3.1.0/esnext/dist/shared/unhead.fg-0ge_u.mjs";
